<template>
    <div>
      <div class="loadmore-wrapper" :style="{height: contentHeight}">
        <mt-loadmore :auto-fill="false" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore">
          <!--<div style="overflow-y: auto;" >-->
            <div v-for="(item,index) in tableData" class="biaoge" :key="index" >
              <div @click="makeQrCode(index)">
                <el-row>
                  <img class="baocun" src="../assets/ka2.png" width="30px;" height="25px;"/>
                  <el-col :span="11" v-if="item.clientCode.length>12"><div class="bianhao">{{item.clientCode.substr(0,4) + "****" + item.clientCode.substr(-4)}}</div>
                  </el-col>
                  <!--<el-col :span="9" v-else><span>{{item.ClientMstCode}}</span></el-col>-->
                  <el-col :span="11" v-else><div class="bianhao">{{item.clientCode}}</div></el-col>
                  <el-col :span="8"><div class="mingzi">{{item.housingEstateName}}</div></el-col>
                </el-row>
                <el-col :span="8" style="margin-left: 51.5%"><div class="scewm">生成缴费二维码</div></el-col>
              </div>
              <div style=" width: 48px;height: 82px;position: relative;left: 87%;top: -36px" @click="shanchu(index)">
                <img class="shanchu" src="../assets/sc.png" width="27" height="27"/>
              </div>
            </div>
          <!--</div>-->
        </mt-loadmore>
        <div class="kong" v-show="show">
          <img class="wushuju" src="../assets/wushuju.png" width="120" height="80"/><br/>
          <span>未绑定房产</span>
        </div>
      </div>
      <div class="div2">
        <el-button style="width: 70%;" type="success" size="small"  @click="tianJia()">添加</el-button>
      </div>
    </div>
</template>

<script>
    import { Toast, MessageBox, Loadmore } from 'mint-ui'
    export default {
        name: "HouseProperty",
      data () {
        return {
          contentHeight: window.innerHeight - 60 + 'px',
          states: 1,
          // openID: 'o5vFewIMieT8e-ScGJBzmXVfmxNA',
          openID: this.$store.getters.getUserInfo.openID,
          // userID: 2,
          userID: this.$store.getters.getUserInfo.userID,
          offset: 0,
          limit: 10,
          allLoaded: true,
          noMoreInfor: false,
          show: false,
          tableData: [
            // {
            //   clientCode: '98795463254698745698',
            //   housingEstateName: '王小虎',
            // }, {
            //   clientCode: 'qwertyuiopasdfghjklj',
            //   housingEstateName: '王小虎',
            // }, {
            //   clientCode: '12365896523123652563',
            //   housingEstateName: '王小虎王小虎王小虎王',
            // }, {
            //   clientCode: '13251236685455256658',
            //   housingEstateName: '王小虎',
            // },
            // {
            //   clientCode: '98795463254698745698',
            //   housingEstateName: '王小虎',
            // }, {
            //   clientCode: 'qwertyuiopasdfghjklj',
            //   housingEstateName: '王小虎',
            // }, {
            //   clientCode: '12365896523123652563',
            //   housingEstateName: '王小虎王小虎王小虎王',
            // }, {
            //   clientCode: '13251236685455256658',
            //   housingEstateName: '王小虎',
            // },  {
            //   clientCode: '98795463254698745698',
            //   housingEstateName: '王小虎',
            // }, {
            //   clientCode: 'qwertyuiopasdfghjklj',
            //   housingEstateName: '王小虎',
            // }, {
            //   clientCode: '12365896523123652563',
            //   housingEstateName: '王小虎王小虎王小虎王',
            // }, {
            //   clientCode: '13251236685455256658',
            //   housingEstateName: '王小虎',
            // }
          ]
        }
      },
      methods: {
        loadBottom: function () {
          this.getHousingList()
          // alert(this.offset)
          this.$refs.loadmore.onBottomLoaded()
        },
        makeQrCode (index) {
          this.$router.push({name: 'qrCode',query: {codeId: this.tableData[index].clientCode}});
        },
        tianJia (){
          this.$router.push({name:'addHouseProperty'})
        },
        getHousingList (){
          let params = {
            userID: this.userID,
            openID: this.openID,
            offset: this.offset,
            limit: this.limit
          }
          this.$http.getHousingList(params).then(response => {
            console.log(response)
            if (response.state !== 1) {
                return
            }
            if (this.states == 0){
              this.tableData = []
            }
            let length = response.data.row.length
            if (length > 0){
              this.tableData = this.tableData.concat(response.data.row)
              this.show = false
              this.states = 1
            }
            if (this.tableData.length == 0) {
              this.show = true
            }
            this.offset = this.tableData.length
            this.allLoaded = (length === 0 || length < this.limit)
          })
        },
        shanchu(index){
          MessageBox.confirm('确认删除信息?').then(action  => {
            let params = {
              userID: this.userID,
              openID: this.openID,
              clientCode: this.tableData[index].clientCode
            }
            this.$http.delHousing(params).then(response => {
              if (response.state === 1){
                Toast({
                  duration: 2000,
                  message: '删除成功'
                })
                this.offset = 0
                this.states = 0
                this.getHousingList()
              } else {
                Toast({
                  duration: 2000,
                  message: '删除失败'
                })
              }
            })
          }).catch()
        }
      },
      beforeRouteLeave (to, from, next) {
        MessageBox.close()
        let toName = to.name
        if ((toName === "updatePhone") || toName === "check") {
          localStorage.clear()
          window.WeixinJSBridge.call('closeWindow')
        } else {
          next()
        }
      },
      created () {
        // this.getUser()
      },
      mounted () {
        this.getHousingList()
      }
    }
</script>

<style scoped>
  .loadmore-wrapper {
    width:100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
  }
  .baocun{
    /*float: left;*/
    /*margin-left: 3%;*/
    position: absolute;
    left: 10px;

  }
  .shanchu{
    position: relative;
    left: 5.5px;
    top: -12px;
    /*margin-top: -100%;*/
    /*margin-left: 13%;*/
  }
  .biaoge{
    padding-top: 3%;
    height: 66px;
    border: 1px;
    border-style: solid;
    border-color: gainsboro white white white;
  }
  .scewm{
    text-align: center;
    color: white;
    font-size: small;
    font-weight: bolder;
    background-color: dodgerblue;
    border-radius: 2px;
    margin-top: 15px;
  }
  .div2{
    position: fixed;
    bottom: 0px;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);
    background-color: #fff;
  }
  .bianhao{
    margin-top: 6px;
    margin-left: 50px;
  }
  .mingzi{
    margin-left:28px;
    margin-top: 4%;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    width: 120px;
  }
  .kong{
    text-align: center;
    color: gray;
    padding-top: 6%;
    border: 1px;
    border-style: solid;
    border-color: gainsboro white white white;
  }
  .wushuju{
    margin-top: 50%;
    margin-bottom: 10px;
  }
</style>
<style>
  .el-message-box--center{
    width: 80%;
    margin-top: -10%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/HouseProperty.vue